import React from "react";
import { Modal, ModalBody, ModalHeader, Row, Col } from "reactstrap";
import {
  faMotorcycle,
  faCheck,
  faPlus
} from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import WithToggle from "./WithToggle";
import ScooterList from "./ScooterList";
import WithFetchScooters from "../containers/WithFetchScooters/index";
import { get } from "lodash";
import ScooterButton from "./ScooterButton";
import Button from "./CustomButton";
import { Card } from "./Card";
import { withHandlers, compose, lifecycle, setDisplayName } from "recompose";
import { connect } from "react-redux";
import { actions } from "../modules/scooters";

let openScooterButtonModal = null;

const ScooterTable = compose(
  setDisplayName("ScooterTable"),
  WithFetchScooters,
  withHandlers({
    onSelectScooter: ({ setCurrentScooter, toggle }) => scooter => ev => {
      setCurrentScooter(scooter);
      toggle();
    },
    isSelected: props => scooter =>
      get(props, "currentScooter.id", "") === scooter.id
  })
)(({ scooters, isSelected, onSelectScooter }) => (
  <ScooterList scooters={scooters || []}>
    {({ scooter }) => (
      <Button
        fill={isSelected(scooter)}
        onClick={onSelectScooter(scooter)}
        color={isSelected(scooter) ? "primary" : "default"}
      >
        Select <FontAwesomeIcon icon={faCheck} />
      </Button>
    )}
  </ScooterList>
));

const withScooterState = connect(
  null,
  {
    setCurrentScooter: actions.setCurrentScooter
  }
);

const SelectScooterButton = compose(
  WithToggle,
  withScooterState,
  lifecycle({
    componentDidMount() {
      const { defaultOpen, show } = this.props;
      defaultOpen && show();
    }
  }),
  withHandlers({
    onSubmitSuccess: ({ toggle, setCurrentScooter }) => scooter => {
      toggle();
      setCurrentScooter(scooter);
    },
    onFetchSuccess: ({
      toggle,
      setCurrentScooter,
      currentScooter
    }) => scooters => {
      if (Array.isArray(scooters)) {
        if (scooters.length === 1 && !currentScooter) {
          toggle();
          setCurrentScooter(scooters[0]);
        }
        if (scooters.length === 0) {
          openScooterButtonModal();
        }
      }
    }
  })
)(props => {
  const {
    toggledOn,
    toggle,
    currentScooter,
    onSubmitSuccess,
    onFetchSuccess
  } = props;
  return (
    <div style={{ marginBottom: 10 }}>
      <Modal isOpen={toggledOn} toggle={toggle} size="lg">
        <Card
          plain
          content={
            <div>
              <ModalHeader toggle={toggle}>
                <h3 className="title">Select Scooter</h3>
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col>
                    <ScooterButton
                      formAction="create"
                      onSubmitSuccess={onSubmitSuccess}
                    >
                      {({ onClick, show }) => {
                        openScooterButtonModal = show;
                        return (
                          <Button fill onClick={onClick} color="primary">
                            Add Scooter <FontAwesomeIcon icon={faPlus} />
                          </Button>
                        );
                      }}
                    </ScooterButton>
                  </Col>
                </Row>
                <ScooterTable {...props} fetchCompletion={onFetchSuccess} />
              </ModalBody>
            </div>
          }
        />
      </Modal>
      <Button color="primary" onClick={toggle}>
        {`${!currentScooter ? "Select" : "Change"} Scooter`}{" "}
        <FontAwesomeIcon icon={faMotorcycle} />
      </Button>
    </div>
  );
});

export default SelectScooterButton;
